import { render, staticRenderFns } from "./ZonaDescargas.vue?vue&type=template&id=f3c05528"
import script from "./ZonaDescargas.vue?vue&type=script&setup=true&lang=js"
export * from "./ZonaDescargas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports